import Pusher from "pusher-js";
import getAPIRoot from "../api-root";

export default new Pusher(window.__env.PUSHER_KEY, {
  // mt1 is the us-east-1 region for pusher, and is the default region
  // if no PUSHER_CLUSTER is defined.
  cluster: window.__env.PUSHER_CLUSTER || "mt1",
  encrypted: true,
  authEndpoint: `${getAPIRoot()}/auth/pusher/agent/`
});
